module.exports = __webpack_public_path__ + "static/media/industry_icon.01b65225.svg";